// Copyright (C) 2017-2025 Smart code 203358507

const FiltersModal = require('./FiltersModal');

module.exports = FiltersModal;
